// EDCL-350 (RS)
import useFeatureFlag from 'hooks/useFeatureFlag'
import { ZEBRA_STORAGE_SECURE_FILE_MGMT } from 'constants/FeatureFlagConstant'

const useMyFilesEnabled = () => {
    return useFeatureFlag(ZEBRA_STORAGE_SECURE_FILE_MGMT)
}

export default useMyFilesEnabled